export function checkDataValue(data: string | number) {
  return data ? data : '--';
}
